<template>
  <v-row no-gutters>
    <v-col class="px-2" md="4" cols="12">
      <v-text-field :value="user.name + ' ' + user.surname" :label="$t('global.nameAndSurname')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.phone != null && user.phone.length > 0" cols="12">
      <v-text-field :value="user.phone" :label="$t('global.phone')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.birth_date != null && user.birth_date.length > 0" cols="12">
      <v-text-field :value="user.birth_date" :label="$t('user.birthDate')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.email != null && user.email.length > 0" cols="12">
      <v-text-field :value="user.email" label="Email" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.document_number != null && user.document_number.length > 0" cols="12">
      <v-text-field :value="user.document_number" :label="$t('user.documentNumber')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.document_expire != null && user.document_expire.length > 0" cols="12">
      <v-text-field :value="user.document_expire" :label="$t('user.documentExpire')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.document_issue_place != null && user.document_issue_place.length > 0" cols="12">
      <v-text-field :value="user.document_issue_place" :label="$t('global.documentIssuePlace')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.residence_address != null && user.residence_address.length > 0" cols="12">
      <v-text-field :value="user.residence_address" :label="$t('global.residenceAddress')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.nationality != null && user.nationality.length > 0" cols="12">
      <v-text-field :value="user.nationality" :label="$t('global.nationality')" readonly />
    </v-col>
    <v-col class="px-2" md="4" v-if="user.middle_name != null && user.middle_name.length > 0" cols="12">
      <v-text-field :value="user.middle_name" :label="$t('global.middleName')" readonly />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AdminPassengerDataPreview",
  props: {
    user: {
      required: true
    }
  }
};
</script>

<style scoped />
